import { generarTicket } from "./generarTicket";
import { createInfraccion } from "../services/api";
import { getStoredUser } from "../utils/session";

const limpiarCamposVacios = (obj) => {
    const limpio = {};
    for (const key in obj) {
        limpio[key] = obj[key] === "" ? null : obj[key];
    }
    return limpio;
};

const validarCamposObligatorios = (form) => {
    const camposGenerales = [
        { key: "agente", nombre: "Nombre del agente" },
        { key: "serieEquipo", nombre: "Serie del Dispositivo" },
        { key: "motivo", nombre: "Motivo" },
        { key: "articulos", nombre: "Artículos aplicados" },
        { key: "incidencia", nombre: "Incidencia" },
        { key: "calle", nombre: "Calle" },
        { key: "entreCalle", nombre: "Entre Calle" },
        { key: "yCalle", nombre: "Y Calle" },
        { key: "municipio", nombre: "Municipio" },
        { key: "colonia", nombre: "Colonia" },
        { key: "seRetuvo", nombre: "Se retuvo" },
        { key: "placas", nombre: "Placas del vehículo" },
        { key: "serieAuto", nombre: "Serie del vehículo" },
        { key: "expedidoEn", nombre: "Lugar de expedición del vehículo" },
        { key: "marca", nombre: "Marca del vehículo" },
        { key: "submarca", nombre: "Submarca del vehículo" },
        { key: "color", nombre: "Color del vehículo" },
        { key: "modelo", nombre: "Modelo del vehículo" },
    ];

    const camposConductor = [
        { key: "nombre", nombre: "Nombre del infractor" },
        { key: "apellidoPaterno", nombre: "Apellido paterno del infractor" },
        { key: "apellidoMaterno", nombre: "Apellido materno del infractor" },
        { key: "calleInfractor", nombre: "Calle del infractor" },
        { key: "estadoInfractor", nombre: "Estado del infractor" },
        { key: "licencia", nombre: "Licencia del infractor" },
        { key: "emision", nombre: "Fecha de emisión de la licencia" },
        { key: "coloniaInfractor", nombre: "Colonia del infractor" },
        { key: "municipioInfractor", nombre: "Municipio del infractor" },
        { key: "vigencia", nombre: "Vigencia de la licencia" },
        { key: "tipoLicencia", nombre: "Tipo de licencia" },
    ];

    const requeridos = [...camposGenerales];

    if (!form.conductorAusente) {
        if (form.sinLicencia) {
            const camposFiltrados = camposConductor.filter(
                (campo) => !["licencia", "emision", "vigencia", "tipoLicencia", "estadoInfractor"].includes(campo.key)
            );
            requeridos.push(...camposFiltrados);
        } else {
            requeridos.push(...camposConductor);
        }
    }

    const faltantes = requeridos.filter(campo => {
        const valor = form[campo.key];
        return !valor || (Array.isArray(valor) && valor.length === 0);
    });

    if (faltantes.length > 0) {
        const lista = faltantes.map(f => `• ${f.nombre}`).join("\n");
        throw new Error(`Faltan los siguientes campos obligatorios:\n${lista}`);
    }
};

export const guardarInfraccion = async (form, resetForm, handleClear, fotos) => {
    validarCamposObligatorios(form);
    const horaRegistro = new Date().toLocaleTimeString("es-MX", {
        hour12: false
    });
    const nombreInfractor = form.conductorAusente ? "Conductor Ausente" : form.nombre;

    const datosLimpios = limpiarCamposVacios({
        agente: form.agente,
        cantidadUMAs: form.cantidadUMAs,
        cantidadDias: form.cantidadDias,
        incidencia: form.incidencia,
        serie_equipo: form.serieEquipo,
        fecha: form.fecha,
        motivo: form.motivo,
        articulos: form.articulos,
        calle: form.calle,
        entre_calle: form.entreCalle,
        y_calle: form.yCalle,
        municipio: form.municipio,
        colonia: form.colonia,
        se_retuvo: form.seRetuvo,
        conductor_ausente: form.conductorAusente,

        infractor_nombre: nombreInfractor,
        infractor_apellido_paterno: form.apellidoPaterno,
        infractor_apellido_materno: form.apellidoMaterno,
        infractor_rfc: form.rfc,
        infractor_calle: form.calleInfractor,
        infractor_num_exterior: form.exterior,
        infractor_num_interior: form.interior,
        infractor_colonia: form.coloniaInfractor,
        infractor_municipio: form.municipioInfractor,
        infractor_estado: form.estadoInfractor,
        infractor_codigo_postal: form.codigoPostal,
        infractor_licencia: form.licencia,
        infractor_emision: form.emision,
        vigencia: form.vigencia,
        infractor_tipo_licencia: form.tipoLicencia,

        vehiculo_placas: form.placas,
        vehiculo_serie_auto: form.serieAuto,
        vehiculo_expedido_en: form.expedidoEn,
        vehiculo_marca: form.marca,
        vehiculo_submarca: form.submarca,
        vehiculo_color: form.color,
        vehiculo_modelo: form.modelo,
        vehiculo_tarjeta_circulacion: form.tarjetaCirculacion,
        vehiculo_folio_inventario: form.folioInventario,
        vehiculo_deposito: form.deposito,

        foto_panoramica: fotos?.panoramica || null,
        foto_placa: fotos?.placa || null,
        foto_licencia: fotos?.licencia || null,
        foto_tarjeta: fotos?.tarjeta || null,
        hora: horaRegistro,
    });

    let infraccionCreada;
    try {
        infraccionCreada = await createInfraccion(datosLimpios);
    } catch (error) {
        console.error("Error al guardar:", error);
        throw new Error("Error al guardar en la base de datos.");
    }

    const agenteData = getStoredUser();
    const id =
        infraccionCreada?.id ||
        infraccionCreada?.folio ||
        infraccionCreada?.infraccion?.id ||
        infraccionCreada?.data?.id ||
        infraccionCreada?.data?.folio;

    if (!id) {
        throw new Error("La infraccion se guardo, pero el servidor no devolvio el folio.");
    }

    form.nombreAgente = agenteData?.nombre || form.agente || "";
    form.nominaAgente = agenteData?.nomina || "";
    form.nombre = nombreInfractor;
    form.hora = horaRegistro;

    await generarTicket(form, id);
    console.log("Folio generado:", id);

    resetForm();
    handleClear();
};
